export function generateId(length = 16) {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function qs<T extends Element = HTMLElement>(sel: string, root: Document | HTMLElement = document) {
  return root.querySelector(sel) as T | null;
}


